import {
  REQUEST_USER_DETAILS,
  RECEIVE_USER_DETAILS,
} from '../constants/actionTypes';

export function reqUserDetails(id, shouldFetchFeatures) {
  return {
    type: REQUEST_USER_DETAILS,
    id,
    shouldFetchFeatures,
  };
}

export function receiveUserDetails(userDetails) {
  return {
    type: RECEIVE_USER_DETAILS,
    userDetails,
  };
}
